// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from '../locales/en/common.json';
import deCommon from '../locales/de/common.json';

i18n
  .use(initReactI18next) // Bind i18next to react-i18next
  .init({
    resources: {
      en: { common: enCommon },
      de: { common: deCommon },
    },
    ns: ['common'],
    defaultNS: 'common',
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language in case the selected language is missing
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n; // Make sure to export it
